import { heroShape, myPict, socials } from "../config";

const Hero = () => {
  return (
    <section id="home" className="flex items-center mb-32 md:mb-64">
      <div className="flex-1 pl-5 md:pl-32 mt-32">
        <p className="text-lg font-light">hey there</p>
        <h1 className="text-6xl font-medium mt-1 mb-3">
          I'm <span className="text-primary">Akbar</span> Putra
        </h1>
        <p className="text-lg font-light text-gray-300 uppercase">
          front-end developer & ui designer
        </p>

        <div className="flex gap-3 mt-3">
          {socials.map((social) => (
            <a
              key={social.id}
              href={social.url}
              target="_blank"
              rel="noreferrer"
              className="w-8 h-8 bg-black hover:bg-primary transition ease-in-out rounded-full mt-3 flex items-center justify-center"
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>
      <div className="hidden md:block flex-1">
        <div
          style={{
            width: 800,
            height: 800,
            backgroundImage: `url(${myPict})`,
            backgroundSize: "cover",
            backgroundPosition: 'center',
            maskImage: `url(${heroShape})`,
            maskSize: '100%',
            maskRepeat: 'no-repeat',
            maskPosition: 'center',
            WebkitMaskImage: `url(${heroShape})`,
            WebkitMaskSize: '100%',
            WebkitMaskRepeat: 'no-repeat',
            WebkitMaskPosition: 'top',
          }}
        ></div>
      </div>
    </section>
  );
};

export default Hero;
